<template>
  <div class="borrowerAttributeMultiSelectCheckbox">
    <BorrowerAttributeConstructor
      :questionText="questionText"
      :description="description"
      :descriptionTooltip="descriptionTooltip"
      :label="label"
      :tooltipText="tooltipText"
      :errorText="errorText"
      :helpText="helpText"
      :disclaimer="disclaimer">
      <template v-slot:input>
        <div class="d-flex form-check" v-for="(option, index) in question.options" :key="index">
          <input type="checkbox"
            class="form-check-input"
            :id="'ba-' + question.id + '-' + index"
            :name="'ba-' + question.id + '-' + index"
            :value="option.value"
            :data-cy="question.alias + '-' + option.value"
            @change="onChange(v$.selectedObjects, selectedObjects)"
            @blur="onBlur(v$.selectedObjects)"
            v-model="selectedObjects"
          />
          <label
          class="form-check-label ps-3"
            :for="'ba-' + question.id + '-' + index"
            :tabindex="index + 1">
              {{ option.label }}
          </label>
        </div>
      </template>
    </BorrowerAttributeConstructor>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core'
  import { required, requiredIf } from '@vuelidate/validators'
  import split from 'lodash/split'
  import get from 'lodash/get'
  import BorrowerAttributeConstructor from './BorrowerAttributeConstructor.vue'

  export default {
    components: {
      BorrowerAttributeConstructor,
    },
    setup: () => ({ v$: useVuelidate() }),
    data () {
      return {
        selectedObjects: [],
        selectedValues: '',
        placeholderMessage: 'This field is required',
        errorMessage: 'This field is required'
      }
    },
    props: {
      question: Object,
      disabled: Boolean,
      v: Object
    },
    emits: ['invalidity','answer'],
    created () {
      this.$watch('invalid', (invalid) => {
        this.$emit('invalidity', invalid)
      }, {immediate: true})

      switch (this.question.alias) {
        case 'pppLoanPurpose':
          this.placeholderMessage = 'Select Loan Purpose'
          this.errorMessage = 'Please select a loan purpose'
          if(!this.question.value) {
            this.selectedObjects = ['payroll']
            this.$emit('answer', { value: 'payroll', isInvalid: false })
          }
          break
        default:
          this.errorMessage = 'This field is required'
          this.placeholderMessage = 'This field is required'
      }

      if (this.question.value) {
        this.selectedObjects = split(this.question.value, ',')
      }
    },
    computed: {
      invalid() {
        return this.v$.$invalid
      },
      payrollSelected () {
        return this.selectedObjects.includes('payroll');
      },
      questionText() {
        return this.question.questionText || ''
      },
      description() {
        return this.question.description || ''
      },
      descriptionTooltip() {
        return this.question.descriptionTooltip || ''
      },
      label() {
        return this.question.name || ''
      },
      tooltipText() {
        return this.question.tooltip || this.question.helpText || ''
      },
      helpText() {
        return this.question.tooltip ? this.question.helpText : ''
      },
      errorText() {
        return get(this.v$, 'selectedObjects.$error') ? this.errorMessage : ''
      },
      disclaimer() {
        if (this.question.alias === 'pppLoanPurpose' && !this.payrollSelected) {
          return "Deselecting 'Payroll' may disqualify yourself from loan funds and loan forgiveness."
        }
        return this.question.disclaimer || ''
      },
    },
    methods: {
      onChange (v$, e) {
        if (!v$.invalid) {
          v$.$touch()
        }
        this.selectedValues = this.selectedObjects.join()
        this.$emit('answer', { value: this.selectedValues, isInvalid: v$.$error })
      },
      onBlur (v$) {
        v$.$touch()
      },
    },
    validations() {
      let validations
      if (this.question.alias === 'pppLoanPurpose') {
        validations = {
          selectedObjects: {
            required: requiredIf(() => {
              return false
            }),
          }
        }
      } else {
        validations = {
          selectedObjects: {
            required
          }
        }
      }
      return {
        ...validations,
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import 'vue-multiselect/dist/vue-multiselect.css';

  .multiselect--active {
    z-index: 999;
  }

  .multiselect__tag {
    background: $blue;
    margin-bottom: 0;
  }

  .multiselect__select {
    height: 40px;
  }

  .multiselect__tag-icon:after {
    color: #fff;
  }

  .multiselect__tags {
    border-color: $border-100;
  }

  .multiselect__option--selected.multiselect__option--highlight, .multiselect__option--selected.multiselect__option--highlight::after  {
    background: darken($blue, 5%);
  }

  .multiselect__option--selected, .multiselect__option--selected::after {
    background: $blue;
    color: $white;
  }

  .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
    background: darken($blue, 5%);
  }

  .multiselect__option--highlight {
    background: $background-100;
    color: black;
    font-weight: bold;
    &::after {
      background: $background-100;
      color: black;
      font-weight: bold;
    }
  }

  .multiselect.is-invalid {
    .multiselect__tags {
      border-color: $red-300;
    }
  }

  .payroll-feedback {
    color: rgb(180, 180, 180);
  }
</style>
